<template>
  <a-form @submit="handleSubmit" :form="form" class="form">
    <a-row class="form-row" :gutter="16">
      <a-col :lg="colSet.lg" :md="colSet.md" :sm="colSet.sm">
        <a-form-item label="产权年限（年）">
          <a-input-number 
            :min="0"
            placeholder="请输入产权年限"
            v-decorator="[
              'term'
            ]" />
        </a-form-item>
      </a-col>
      <a-col :lg="colSet.lg" :md="colSet.md" :sm="colSet.sm">
        <a-form-item label="交房时间">
          <a-date-picker
            style="width: 100%"
            v-decorator="[
              'deliveryTime'
            ]" />
        </a-form-item>
      </a-col>
      <a-col :lg="colSet.lg" :md="colSet.md" :sm="colSet.sm">
        <a-form-item label="开盘时间">
          <a-date-picker
            style="width: 100%"
            v-decorator="[
              'openTime'
            ]" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-form-item v-if="showSubmit">
      <a-button htmlType="submit" >Submit</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
export default {
  name: 'RepositoryForm',
  props: {
    showSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      gridSet: {
        label: { lg: { span: 8 }, sm: { span: 8 } },
        wraper: { lg: { span: 10 }, sm: { span: 10 } }
      },
      colSet: {
        lg: 8,
        md: 12,
        sm: 24
      }
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values, '基本信息')
          // this.$notification['error']({
          //   message: 'Received values of form:',
          //   description: values
          // })
        }
      })
    },
    validate (rule, value, callback) {
      const regex = /^user-(.*)$/
      if (!regex.test(value)) {
        callback(new Error('需要以 user- 开头'))
      }
      callback()
    }
  }
}
</script>

<style scoped>

</style>
